import type { AnalyticsDestination, AnalyticsTraits, EventProperties } from "@/lib/analytics/analytics.types";
import { isSentinelValue } from "@/lib/env";

type HsqCommand =
  | ["setPath", string]
  | ["trackPageView"]
  | ["identify", AnalyticsTraits]
  | ["trackCustomBehavioralEvent", { name: string; properties?: EventProperties }];

declare global {
  interface Window {
    _hsq?: HsqCommand[];
  }
}

const enabled = (): boolean =>
  typeof window !== "undefined" &&
  !!process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID &&
  !isSentinelValue(process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID) &&
  process.env.NODE_ENV !== "test";

const queue = (): HsqCommand[] | null => {
  if (!enabled()) {
    return null;
  }
  window._hsq = window._hsq ?? [];
  return window._hsq;
};

export const hubspotDestination: AnalyticsDestination = {
  name: "hubspot",
  isEnabled: enabled,
  pageView: (path) => {
    const q = queue();
    if (!q) {
      return;
    }
    q.push(["setPath", path]);
    q.push(["trackPageView"]);
  },
  track: (name, properties) => {
    queue()?.push(["trackCustomBehavioralEvent", { name, properties }]);
  },
  identify: (traits) => {
    queue()?.push(["identify", traits]);
  },
  reset: () => {
    // HubSpot has no client-side reset; rely on cookie expiry.
  },
};
